import React, { type ReactNode } from 'react';
import { Center } from '@fiverr-private/layout_components';

const IconWrapper = ({ children }: { children: ReactNode }) => (
  <Center flexShrink={0} height={18}>
    {children}
  </Center>
);

IconWrapper.displayName = 'HighlightIconWrapper';

export default IconWrapper;
